import type { LimitOrderForm } from 'state/secondaryMarket/limit-order/form/input/inputForm.model';
import type { OriginalForm } from 'state/secondaryMarket/shared/form/original/original.model';
import type { Collection } from 'state/utils/types';

export type SecondaryMarketLimitOrderReloadedForm = OriginalForm<LimitOrderForm>;

export type SecondaryMarketLimitOrderReloadedFormMap = Collection<SecondaryMarketLimitOrderReloadedForm>;

export const initialLimitOrderReloadedFormMap: SecondaryMarketLimitOrderReloadedFormMap = {};
export const initialLimitOrderReloadedForm: SecondaryMarketLimitOrderReloadedForm = {
  tradeSizeInputMode: undefined,
  clientType: 'Other',
};
